import React from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';

import Project from 'types/Project';
import Link from 'components/core/Link';
import ProjectContact from 'components/project/ProjectContact';
import { useServices } from 'services';
import JoinButton from 'components/project/JoinButton';

const Root = styled.li({
  listStyle: 'none',
  margin: 0,
  display: 'flex',
  width: '100%',
  borderBottomStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#AAA7A7',
  padding: '1rem 0 2rem 0',
});

const ImageWrapper = styled.div({
  flex: '0 0 14rem',
  display: 'flex',
  justifyContent: 'center',
});
const Image = styled.img({
  width: '100%',
  padding: '0rem 1rem 5rem 1rem',
});

const ContentWrapper = styled.div({
  display: 'flex',
  flex: '1 1 100%',
});

const TextContent = styled.div({
  flex: '1 1 auto',
  paddingRight: '2rem',
});

const Description = styled(Typography)({
  margin: 0,
  marginBottom: '1.5rem',
});
const Title = styled(Typography)(({ theme: { palette, typography } }) => {
  return {
    color: palette.primary.main,
    fontFamily: typography.h1.fontFamily,
    margin: 0,
    paddingBottom: '0rem',
  };
});
const Subtitle = styled(Typography)({
  fontSize: '1.125rem',
  marginBottom: '0.25rem',
  paddingBottom: '0.5rem',
  fontWeight: 'bold',
});
export interface ProjectPaperProps {
  className?: string;
  project: Project;
}
// https://mui.com/
// litterally copied from https://mui.com/material-ui/react-grid/#complex-grid
function ProjectPaper(props: ProjectPaperProps): React.ReactElement | null {
  const { className, project } = props;
  const { envService } = useServices();

  return (
    <Root className={className}>
      <ImageWrapper>
        <div>
          <Image
            alt=""
            src={`${envService.getValue('DATA_REPO_URL')}/api/projects/${
              project.id
            }/logo`}
          />
        </div>
      </ImageWrapper>
      <ContentWrapper>
        <TextContent>
          <Title variant="h2">
            <Link to={`/projects/${project.slug}/info`}>{project.title}</Link>
          </Title>
          <Subtitle variant="subtitle2">{project.subtitle}</Subtitle>
          <Description>{project.description}</Description>
          <div>
            <ProjectContact contact={project.contact} />
          </div>
        </TextContent>
        <div>
          <JoinButton project={project} includeEdit={false} />
        </div>
      </ContentWrapper>
    </Root>
  );
}

export default observer(ProjectPaper);
